import axios from "axios";
import { userTokenHeader } from "@/lib/userToken";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/lyrics/rooms`;
const NAME_KEY = "elpm-cowriter-name";
const hdr = () => ({ headers: userTokenHeader(), timeout: 20_000 });

export const roomUrl = (id) => `${window.location.origin}/write/${id}`;

export function getCowriterName() {
  try { return localStorage.getItem(NAME_KEY) || ""; } catch (e) { void e; return ""; }
}
export function setCowriterName(name) {
  try { localStorage.setItem(NAME_KEY, name); } catch (e) { void e; }
}

export const createRoom = (body) => axios.post(API, body, hdr()).then((r) => r.data);
export const getRoom = (id) => axios.get(`${API}/${id}`, hdr()).then((r) => r.data);
export const updateRoom = (id, body) => axios.put(`${API}/${id}`, body, hdr()).then((r) => r.data);
export const listMyRooms = () => axios.get(API, hdr()).then((r) => r.data);
export const addComment = (id, body) => axios.post(`${API}/${id}/comments`, body, hdr()).then((r) => r.data);
export const resolveComment = (id, cid) => axios.post(`${API}/${id}/comments/${cid}/resolve`, null, hdr()).then((r) => r.data);
export const deleteComment = (id, cid) => axios.delete(`${API}/${id}/comments/${cid}`, hdr()).then((r) => r.data);

/** Replace the line a comment points at with its suggestion (line_key "section-line"). Returns new lyrics or null. */
export function applySuggestion(lyrics, comment) {
  if (!comment?.suggestion || !/^\d+-\d+$/.test(comment.line_key || "")) return null;
  const [si, li] = comment.line_key.split("-").map(Number);
  const sections = [];
  let cur = { header: null, lines: [] };
  for (const ln of String(lyrics || "").split(/\r?\n/)) {
    const m = ln.trim().match(/^\[(.+?)\]\s*$/);
    if (m) { if (cur.header !== null || cur.lines.length) sections.push(cur); cur = { header: m[1], lines: [] }; } else cur.lines.push(ln);
  }
  if (cur.header !== null || cur.lines.length) sections.push(cur);
  const want = String(comment.line_text || "").trim();
  let target = sections[si] && sections[si].lines[li] != null ? [si, li] : null;
  if (want && (!target || sections[si].lines[li].trim() !== want)) {
    // The line moved since the comment was written — find it by text instead.
    target = null;
    sections.forEach((sec, a) => sec.lines.forEach((ln, b) => { if (!target && ln.trim() === want) target = [a, b]; }));
  }
  if (!target) return null;
  sections[target[0]].lines[target[1]] = comment.suggestion;
  return sections.map((s) => (s.header ? `[${s.header}]\n` : "") + s.lines.join("\n")).join("\n").trim();
}
